export default "__VITE_PUBLIC_ASSET__8fb95516__"